export const OVERVIEW_SUMMARY_NOTES = {
  totalTests: "The total number of PVT tests in the dataset",
  cceTests:
    "The number of Constant Composition Expansion (CCE) tests in the dataset.",
  dlTests: "The number of Differential Liberation (DL) tests in the dataset.",
  separatorTests: "The number of Separator tests in the dataset.",
  passRate:
    "Overall percentage of PVT tests that have passed quality control across all test types in the dataset.",
};

export const OVERVIEW_QC_STATUS_NOTES = {
  passed:
    "Tests that have satisfied all applicable quality control criteria and are marked as passed.",
  needsReview:
    "Tests that require manual review or additional verification before a final quality control outcome can be assigned.",
  failed:
    "Tests that did not satisfy one or more quality control criteria and are marked as failed.",
};
